module.exports = __webpack_public_path__ + "static/media/Engineering-support.369ff5ce.jpg";